(function () {
  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }

    callback();
  }

  function setProductDescriptionLinks() {
    document.querySelectorAll('.tabs-content a').forEach(function (link) {
      link.setAttribute('rel', 'noreferrer noopener');
      link.setAttribute('target', '_blank');
    });
  }

  function replaceEncodedQuotes(root) {
    if (!root) return;

    var selector = '.product-option dt, .bold_line_property';
    var scope = root.nodeType === 1 ? root : root.parentElement || root;
    if (!scope.querySelectorAll) return;

    var elements = [];
    if (scope.matches && scope.matches(selector)) {
      elements.push(scope);
    }
    scope.querySelectorAll(selector).forEach(function (element) {
      elements.push(element);
    });

    elements.forEach(function (element) {
      if (element.innerHTML && element.innerHTML.indexOf('%22') !== -1) {
        element.innerHTML = element.innerHTML.replace(/%22/g, '"');
      }
    });
  }

  function initProductDescriptionLinks() {
    var $ = window.jQuery;

    if ($) {
      $('.tablinks').on('click', setProductDescriptionLinks);
      return;
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('.tablinks')) {
        setProductDescriptionLinks();
      }
    });
  }

  function initCartQuoteCleanup() {
    replaceEncodedQuotes(document);

    if (!document.body) return;

    if ('MutationObserver' in window) {
      var scheduled = false;
      var pendingRoots = new Set();
      var observer = new MutationObserver(function (records) {
        records.forEach(function (record) {
          record.addedNodes.forEach(function (node) {
            var root = node.nodeType === 1 ? node : node.parentElement;
            if (root) pendingRoots.add(root);
          });
        });

        if (scheduled || !pendingRoots.size) return;

        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          var roots = Array.from(pendingRoots);
          pendingRoots.clear();
          roots.forEach(replaceEncodedQuotes);
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      return;
    }

    var attempts = 0;
    var interval = window.setInterval(function () {
      replaceEncodedQuotes(document);
      attempts += 1;

      if (attempts >= 120) {
        window.clearInterval(interval);
      }
    }, 500);
  }

  function initLazyImages() {
    var lazyloadImages = Array.prototype.slice.call(document.querySelectorAll('.lazy[data-src]'));

    if (!lazyloadImages.length) return;

    function loadImage(image) {
      image.src = image.dataset.src;
      image.classList.remove('lazy');
    }

    if ('IntersectionObserver' in window) {
      var imageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadImage(entry.target);
            observer.unobserve(entry.target);
          }
        });
      });

      lazyloadImages.forEach(function (image) {
        imageObserver.observe(image);
      });
      return;
    }

    var lazyloadThrottleTimeout;

    function lazyload() {
      if (lazyloadThrottleTimeout) {
        window.clearTimeout(lazyloadThrottleTimeout);
      }

      lazyloadThrottleTimeout = window.setTimeout(function () {
        var scrollTop = window.pageYOffset;

        lazyloadImages.forEach(function (image) {
          if (image.offsetTop < window.innerHeight + scrollTop) {
            loadImage(image);
          }
        });

        lazyloadImages = lazyloadImages.filter(function (image) {
          return image.classList.contains('lazy');
        });

        if (!lazyloadImages.length) {
          document.removeEventListener('scroll', lazyload);
          window.removeEventListener('resize', lazyload);
          window.removeEventListener('orientationchange', lazyload);
        }
      }, 20);
    }

    document.addEventListener('scroll', lazyload);
    window.addEventListener('resize', lazyload);
    window.addEventListener('orientationchange', lazyload);
    lazyload();
  }

  function initTabs() {
    var headActive = document.querySelector('.tab-head');
    var tabActive = document.querySelector('.tab-content');

    if (headActive) {
      headActive.classList.add('active');
    }

    if (tabActive) {
      tabActive.classList.remove('hide');
      tabActive.classList.add('active');
    }
  }

  function initAccordions() {
    document.querySelectorAll('.accordion').forEach(function (accordion) {
      accordion.addEventListener('click', function () {
        var panel = accordion.nextElementSibling;
        var arrow = accordion.querySelector('.accordionArrow');

        accordion.classList.toggle('active');

        if (!panel) return;

        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
          if (arrow) arrow.style.transform = 'rotate(0deg)';
          return;
        }

        panel.style.maxHeight = panel.scrollHeight + 'px';
        if (arrow) arrow.style.transform = 'rotate(90deg)';
      });
    });
  }

  function initSwatchPopup() {
    function swatchImageUrl(swatch) {
      var imageTile = swatch && swatch.querySelector('span');
      if (!imageTile) return null;

      var backgroundImage = imageTile.style.backgroundImage || window.getComputedStyle(imageTile).backgroundImage;
      var match = backgroundImage && backgroundImage.match(/^url\(["']?(.*?)["']?\)$/);
      return match ? match[1] : null;
    }

    function showSwatchPopup(swatch) {
      var popup = document.querySelector('.SwatchPopMainDiv');
      var popupContent = document.querySelector('.SwatchPopDiv');
      var popupImage = document.querySelector('.SwatchPopIMG');
      var imageUrl = swatchImageUrl(swatch);
      if (!popup || !popupContent || !popupImage || !imageUrl) return;

      var title = swatch.closest('label')?.querySelector('.bold_option_value_title')?.textContent?.trim();
      popupImage.src = imageUrl;
      popupImage.alt = title || 'Selected product add-on';
      popup.style.display = 'grid';
      popupContent.style.display = 'flex';
    }

    function hideSwatchPopup() {
      document.querySelectorAll('.SwatchPopMainDiv, .SwatchPopDiv').forEach(function (element) {
        element.style.display = 'none';
      });
    }

    function previewEvent(event) {
      var swatch = event.target.closest?.('.bold_option_value_swatch');
      if (!swatch) return;

      var input = swatch.closest('.bold_option_value_element')?.querySelector('input[type="checkbox"]');
      if (input && /^No\b/i.test(input.value.trim())) {
        hideSwatchPopup();
        return;
      }

      showSwatchPopup(swatch);
    }

    // Delegation works even though Bold injects its option markup after load.
    document.addEventListener('mouseover', previewEvent);
    document.addEventListener('focusin', previewEvent);

    // Bold fires change after it has selected a swatch. A product handle marks
    // a real add-on; the "No ..." choice intentionally closes the preview.
    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches?.('.bold_option_swatch input[type="checkbox"]') || !input.checked) return;

      if (!input.dataset.productHandle) {
        hideSwatchPopup();
        return;
      }

      var valueElement = input.closest('.bold_option_value_element');
      showSwatchPopup(valueElement?.querySelector('.bold_option_value_swatch'));
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest?.('.SwatchPopButton')) hideSwatchPopup();
    });
  }

  onReady(function () {
    initProductDescriptionLinks();
    initCartQuoteCleanup();
    initLazyImages();
    initTabs();
    initAccordions();
    initSwatchPopup();
  });
})();
